import axios from 'axios'
import * as types from './mutations_types.js'
//export const API_URL = process.env.mode === 'prod' ? 'https://mwd-dev-api.mywarmday.com' : process.env.mode === 'test' ? 'https://mwd-uat-api.mywarmday.com' : 'http://localhost:8081'
export const API_URL = process.env.mode === 'prod' ? 'https://mwd-dev-api.mywarmday.com' : process.env.mode === 'test' ? 'https://mwd-uat-api.mywarmday.com' : 'https://mwd-dev-api.ptcnec.com.tw'
export const Version = process.env.mode === 'prod' ? 'V5.3.0' : process.env.mode === 'test' ? 'V5.3.0' : 'V5.3.0'
export const POS_URL = process.env.mode === 'prod' ? 'https://mwdipos.ptcnec.com.tw/brand_ScanOrdering_mwd/scanorderImage' : process.env.mode === 'test' ? 'https://mwdue.ngrok.dev/brand_ScanOrdering_mwd/scanorderImage' : 'https://iposdemo.ptcnec.com.tw/brand_ScanOrdering_mwd/scanorderImage'
export const POS_FCM_URL = process.env.mode === 'prod' ? 'https://mwdipos.ptcnec.com.tw/brand_ScanOrdering_fcm/scanorderImage' : process.env.mode === 'test' ? 'https://mwdue.ngrok.dev/brand_ScanOrdering_fcm/scanorderImage' : 'https://iposdemo.ptcnec.com.tw/brand_ScanOrdering_fcm/scanorderImage'
export const BRAND_MWD = "MWD"
export const PREORDER_URL  = process.env.mode === 'prod' ? 'https://preorder-backend.mywarmday.com' : process.env.mode === 'test' ? 'https://uat-preorder-backend.mywarmday.com' : 'https://devqinadmin.happyclick.online'

export const fileUploadMaxSize = 1024 * 1024 * 5
export const state = {
  companyId: 0,
  userID: 0,
  userName: '',
  loading: false,
  memberPerPage: [],
  memberchangepointResult: {},
  searchmemberoneresult: {},
  token: ''
}
export const actions = {
  toggleLoading ({ commit }, isLoading) {
    commit(types.LOADING, isLoading)
  },
  // login
  actionLogin ({ commit }, { account, password }) {
    commit(types.LOADING, true) // 打開遮罩
    return axios.post(API_URL + '/web/signin/v1', {
      account: account,
      password: password
    })
  },
  loadMemberPerPage ({ commit }, id) {
    console.log('loadMemberPerPage')
    commit(types.MEMBER_PER_PAGE, {})
    commit(types.LOADING, true) // 打開遮罩
    return axios.post(API_URL + '/member/get_per_page/v1', {
      pageNumber: 1,
      rowsPerPage: 20
    })
      .then((response) => {
        console.log('2. Promise resolve 0')
        console.log(response.data)
        console.log(response.data.data)
        commit(types.MEMBER_PER_PAGE, response.data.data)
        commit(types.LOADING, false)
      })
      .catch((error) => {
        commit(types.LOADING, false) // 關閉遮罩
        console.log('CATCH')
        console.log(error)
      })
  }
  // LinCY add===================================================
  // actionLogout ({ commit }) {
  //   console.log('1. actionLogout')
  //   commit(types.LOGOUT, {})
  // },
  // LinCY add===================================================
}
export const mutations = {
  [types.LOADING] (state, isLoading) {
    localStorage.setItem('LOADING', isLoading)
    state.loading = isLoading
  },
  // Tina add
  [types.LoginUserName] (state, data) {
    state.userName = data
    localStorage.setItem('LoginUserName', data)
  },
  [types.LoginUserID] (state, data) {
    if (data !== null && !isNaN(data)) {
      state.userID = Number(data)
      localStorage.setItem('LoginUserID', Number(data))
    } else {
      state.userID = 0
      localStorage.setItem('LoginUserID', 0)
    }
  },
  [types.FUNCTION] (state, data) {
    if (data === '') {
      localStorage.setItem('FUNCTION', '')
    } else {
      localStorage.setItem('FUNCTION', JSON.stringify(data))
    }
  },
  // Tina add
  [types.TOKEN] (state, token) {
    if (token === '') {
      state.token = ''
      localStorage.setItem('TOKEN', '')
    } else {
      state.token = token
      localStorage.setItem('TOKEN', token)
    }
  },
  [types.COMPANY] (state, companyId) {
    if (companyId === 0) {
      state.companyId = ''
      localStorage.setItem('COMPANY', '')
    } else {
      state.companyId = companyId
      localStorage.setItem('COMPANY', companyId)
    }
  },
  [types.MEMBER_PER_PAGE] (state, data) {
    if (data !== null) {
      state.memberPerPage = data
    }
  },
  [types.MEMBER_CHANGE_POINT_RESULT] (state, data) {
    if (data !== null) {
      state.memberchangepointResult = { Result: data.Result, Data: data.Data }
    }
  },
  [types.SEARCH_MEMBER_ONE_RESULT] (state, data) {
    if (data !== null) {
      state.searchmemberoneresult = { Result: data.Result, Data: data.Data }
    }
  },
  [types.LOGOUT] (state) {
    state = {
      companyId: 0,
      userName: '',
      userID: 0,
      loading: false,
      memberPerPage: [],
      memberchangepointResult: {},
      searchmemberoneresult: {},
      token: ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/root.js